import { type Key, type PropsWithChildren, useMemo } from "react";

import { Flex } from "@aircall/tractor";

import { AccordionItemProvider } from "../../contexts/AccordionItem";
import { useAccordion } from "../../contexts/hooks/useAccordion";

import type { AccordionItemProps } from ".";

export function AccordionItem<ItemId extends Key>({
  children,
  id,
  ...props
}: PropsWithChildren<AccordionItemProps<ItemId>>) {
  const { openedItems } = useAccordion();
  const isOpened = useMemo(() => openedItems.has(id), [openedItems, id]);

  return (
    <Flex
      flexDirection="column"
      gap="xxxs"
      data-test={`accordion-item-${id}`}
      {...props}
    >
      <AccordionItemProvider id={id} isOpened={isOpened}>
        {children}
      </AccordionItemProvider>
    </Flex>
  );
}
